import useFiltersInfo from 'components/UI/Filter/hooks/useFiltersInfo'
import { useMemo, FC } from 'react'
import { useSelector } from 'react-redux'

import { FilterType } from 'services/types'
import { MFilters } from 'types/filterTypes'
import { useUpdateSettings } from './hooks'
import { Badge } from 'ui'

type FilterSummaryProps = {
  contentName: MFilters.ContentTypes
  filters?: string[]
}

const FilterSummary: FC<FilterSummaryProps> = ({ contentName, filters }) => {
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const filterTypes = useFiltersInfo(contentName, filters)
  const { saveOptions } = useUpdateSettings(contentName)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])

  const filterMap = useMemo(() => {
    const filterInfo = filters ? filterTypes : []
    const filterMap = {}
    for (const { icon, type, options = [] } of filterInfo) {
      for (const { _id, label } of options) {
        filterMap[_id] = { _id, icon, type, label }
      }
    }

    return filterMap
  }, [filters, filterTypes])

  const parsedOptions: FilterType[] = useMemo(() => {
    return Object.keys(savedOptions || {})
      .map(key => {
        if (!Array.isArray(savedOptions[key])) return []
        return savedOptions[key].map((id: string) => filterMap[id])
      })
      .flat()
      .filter(Boolean)
  }, [filterMap, savedOptions])

  return (
    <div className="col">
      <div className="d-flex flex-row row">
        {parsedOptions.map(({ _id, icon, type, label }) => {
          return (
            <div key={_id}>
              <Badge variant="light" className=" border-secondary mr-1">
                <i className={`fa-solid ${icon} mr-1 `}></i>
                {label}
                <i
                  onClick={() => {
                    if (!savedOptions[type]) return
                    saveOptions({ ...savedOptions, [type]: savedOptions[type].filter((id: string) => id !== _id) })
                  }}
                  className="fa-solid fa-times ml-1 pointer-cursor"
                />
              </Badge>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FilterSummary
